import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataTimeService {
  remainTime$ = new BehaviorSubject<number>(0);
  public static nearlyTimer:number = 1000 * 60 * 5; //5 min
  constructor() { }
  public getObservable() {
    return this.remainTime$.asObservable();
  }

  public getRemainingTime(token: Date, currentTime: Date): number {
    const diffMs = token.getTime() - currentTime.getTime();
    return diffMs > 0 ? Math.floor(diffMs / (1000 * 60)) : 0;
  }

}
